<template>
  <div :class="['cm-percentage-card', {'cm-percentage-card--text': data.onlyText}]">
    <CmPiePercentage
      v-if="!data.onlyText"
      size="120"
      borderSize="18"
      fontSize="25"
      :percent="data.value || 0"
      :color="data.color || 'green'"
    />
    <div class="cm-percentage-card__content">
      <h4 class="cm-percentage-card__title">
        {{ data.title }}
      </h4>
      <table>
        <tr>
          <td :class="data.onlyText ? 'black-text' : 'green-text'">
            {{ fNum.format(data.count || 0) }}
          </td>
          <td>
            &nbsp;{{ data.countText || 'шт.' }}
          </td>
        </tr>
        <tr>
          <td class="black-text">{{ fNum.format(data.total || 0) }}</td>
          <td>&nbsp;{{ data.totalText || 'всего' }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import CmPiePercentage from "@/components/library/statistics/elements/CmPiePercentage.vue";

export default {
  components: {
    CmPiePercentage
  },
  props: ["data"]
}
</script>

<style lang="scss">
.cm-percentage-card {
  display: flex;
  padding: 8px 8px 5px;
  .green-text {
    color: rgba(#56AC00, 0.9);
    font-weight: 600;
  }
  .black-text {
    color: rgba(#000000, 0.9);
  }
  &__title {
    color: $color_black_9;
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 8px;
    white-space: nowrap;
  }
  &__content {
    td {
      color: $color-gray-06;
      white-space: nowrap;
      padding-left: 0;
      padding-bottom: 0;
    }
  }
  .cm-pie-percentage {
    margin-right: 5px;
    text {
      font-weight: 600;
      fill: rgba(0, 0, 0, 0.6);
    }
  }
  &--text {
    width: 249px;
    table {
      margin: 0 auto;
    }
    .cm-percentage-card {
      &__title {
        display: none;
      }
      &__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
      }
    }
  }
}
</style>
